<template>
    <div class="px-0 pb-0 card-body">
        <div class="table-responsive">
            <div class="dataTable-wrapper dataTable-loading no-footer sortable searchable fixed-columns">
                <div :class="{ 'loading-animation' : isLoading }" class="dataTable-container">
                    <table id="genericTable" ref="genericTable" class="table table-flush dataTable-table">
                        <thead class="thead-light">
                            <GenericTableHeader :headers="headers" />
                        </thead>
                        <tbody ref="genericTableBody">
                            <tr v-for="(item,index) of items" :key="index">
                                <slot name="row" v-bind="item">
                                </slot>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import GenericTableHeader from "./GenericTableHeader";

    export default {
        name: "GenericTable",
        components: {
            GenericTableHeader
        },
        props: {
            items: {
                type: Array,
                default: () => [],
            },
            headers: {
                type: Array,
                default: () => [
                    {
                        title: "",
                        sort: false,
                    }
                ]
            },
            isLoading: {
                type: Boolean,
                default: false
            }
        },
        emits: ['changed-page', 'row-change', 'header-changed'],
        computed: {
            totalPages() {
                return Math.ceil(this.pagination.total / this.pagination.rows);
            }
        },
        watch: {
            items() {
                let table = this.$refs.genericTable
                table.classList.remove('loading')
            }
        },
        methods: {
            changedPage(index) {
                this.$emit('changed-page', index);
            },
            headerChanged(val) {
                this.$emit('header-changed', val);
            }
        }
    }

</script>

<style scoped>

    .loading-animation {
        position: relative;
        opacity: 0.5;
        transition: opacity 0.5s ease-in-out;
    }

    .loading-animation:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(255, 255, 255, 0.8);
        z-index: 2;
        background-image: url('../../assets/img/spinner2.gif');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 50px 50px;
    }

</style>